<template>
    <div class="container">
      <div class="left">
        <div class="plus">
          <div class="list">
            <div>APP评论分类</div>
            <i class="el-icon-plus" @click="handButton"></i>
          </div>
          <Navigationlist
            @handEdit="handEdit"
            @handList="handList"
            @handDeta="handDeta"
            :ItemData="ItemData"
            :active="active"
          >
          </Navigationlist>
          <el-dialog
            :title="title"
            :visible.sync="pupupTable"
            width="30%"
            modal
            :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="mode"
              :rules="rules"
              ref="mode"
            >
     
              <el-form-item prop="content" label="评论词" v-if="flag" >
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入评论内容"
                  v-model="mode.content"
                ></el-input>
              </el-form-item>
              <el-form-item prop="content" label="评论词"  v-if="show">
                <el-input
                  placeholder="请输入评论内容"
                  v-model="mode.content"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handClickCancel">取 消</el-button>
              <el-button v-if="flag" type="primary" @click="handButtonConfirm"
                >确 定</el-button
              >
              <el-button v-if="show" type="primary" @click="handEaditConfirm"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
  
        <div class="br"></div>
      </div>
  
      <div class="right">
        <div class="flex-list">
         <div>
          <el-input
              size="small"
              clearable
              placeholder="请输入搜索词"
              prefix-icon="el-icon-search"
              v-model="Workers.keyword"
              @clear="clear"
            >
              <el-button
                slot="append"
                @click="handInput"
                :disabled="!Workers.keyword"
                >搜索</el-button
              >
            </el-input>
          </div>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handDetaClick()"
            >新建
          </el-button>
        </div>
        <div class="distance">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="content" label="搜索词"> </el-table-column>
            <el-table-column prop="created_at" label="创建时间">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    @click="handleClick(scope.row)"
                    class="size"
                    type="text"
                    size="small"
                    icon="el-icon-edit-outline"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="text"
                    size="small"
                    @click="handLeButton(scope.row)"
                    class="size"
                    icon="el-icon-delete"
                    style="padding-left: 15px"
                  >
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagingVue
          :Pagination="Pagination"
          :tableData="tableData"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagingVue>
  
        <div>
          <el-dialog
            title="添加搜索词"
            :visible.sync="centerDialogVisible"
            width="30%"
            modal
            :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="useName"
              :rules="rules"
              ref="useName"
            >
              
              <el-form-item prop="content" label="搜索词">
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入搜索词"
                  v-model="useName.content"
                ></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handCancel">取 消</el-button>
              <el-button type="primary" @click="handConfirm">确 定</el-button>
            </span>
          </el-dialog>
  
          <el-dialog
            title="编辑搜索词"
            :visible.sync="Popup"
            width="30%"
            modal
            :close-on-click-modal="false"
            :show-close="false"
            destroy-on-close
            @close="close"
            append-to-body
          >
            <el-form
              class="login-form"
              label-position="top"
              label-width="80px"
              :model="modify"
              :rules="rules"
              ref="modify"
            >
            <el-form-item prop="content" label="搜索">
                <el-input
                  placeholder="请输入搜索词"
                  v-model="modify.content"
                ></el-input>
              </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="handClickCancel">取 消</el-button>
              <el-button type="primary" @click="handClickConfirm"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </template>
  <script>

  import Navigationlist from "../../../components/Navigationlist/Navigationlist.vue";
  import pagingVue from "../../../components/Paging/paging.vue";
  export default {
    name: "Member_role",
    data() {
 
      return {
        title: "",
        show: false,
        flag: false,
        pupupTable: false,
        Popupvisible: false,
        Workers: {
          keyword:"",
          pid: "", //	扩展组ID
          page:"",
        }, //搜索匹配worker
        active: "0",
        //擅长 编辑 id
        delete: {
          id: "",
        },
        Worker: {
          id: "",
        },
        extensionsType: {
          options: "1",
        },
   
        ItemData: [],
        //分页数据
        Pagination: {},
        useName: {
          pid: "",
    
          content: "",
        },
        mode: {
          pid: "0",
    
          content: "",
        }, //编辑和新增
        modelList :{
          id:"",
          pid:"",
          content:""
         },
        modify: {
          id:"",
          pid: "",
          content: "",
        },
         
        tableData: [],
        centerDialogVisible: false,
        Popup: false,
  
        rules: {

          content: [
            { required: true, message: "请输入内容", trigger: "blur" },
         ],
        },
      };
    },
    components: {
      Navigationlist,
      pagingVue,
    },
    created() {
      this.Itemlist();
    },
    // mounted() {
    //   this.devicesList();
  
    // },
    
    methods: {
      clear() {
        this.devicesList();
      },
      handInput(){
        this.devicesList();
      },
      handButton() {
        this.flag = true;
        this.show = false;
        this.title = "新增评论词";
        this.pupupTable = true;
      },
      handList(params) {
        console.log(params, 111);
        let { id, item } = params;
        this.active = id.toString();
        sessionStorage.setItem("pid", item.id);
        this.Workers.pid = item.id;
        this.useName.pid = item.id;
        this.devicesList();
      },
      //查询状态
  
      //新增扩展
      handButtonConfirm() {
    
        this.$refs.mode.validate(async (valid) => {
          if (valid) {
            let item = this.mode.content.replace(/\n|\r\n/g, "##");
          let list = item.split("##").filter((s) => s && s.trim()).join("##");
          let b = list.replace(/^\"|\"$/g, "").replace(/^\s+|\s+$/g, "");
           let model ={
            pid :this.mode.pid,
            content :b

           }
            const res = await this.$axios.postListData("admin/comments",model);
            if (res.code == 200) {
              this.pupupTable = false;
              this.Itemlist();
              this.mode.content = "";
            }
          } else {
            return false;
          }
        });
      },
     
      //扩展组列表
      async Itemlist() {
        const res = await this.$axios.getListData(
          "admin/comments",
          this.extensionsType
        );
        if (res.code == 200) {
          if (res.data.length) {
          
            this.active = res.data[0].id.toString();
            this.Workers.pid = res.data[0].id.toString();
            sessionStorage.setItem("extension_id", res.data[0].id.toString());
            this.useName.pid = res.data[0].id.toString();
            this.devicesList();
          }
          
          if (Object.keys(res.data).length != 0) {
            this.ItemData = res.data;
          } else {
            this.ItemData = [];
          }
        }
      },
      //编辑扩展组
      handEdit(params) {
        console.log(params)
        let { content,id,pid } = params;
        this.modelList.id = id
        this.modelList.pid  =pid
        this.$set(this.mode, "content", content);
        this.show = true;
        this.flag = false;
        this.title = "编辑worker组";
        this.pupupTable = true;
      },
      //确定编辑内容
      handEaditConfirm() {
        this.modelList.content = this.mode.content
        this.$refs.mode.validate((valid) => {
          if (valid) {
            this.$axios
              .postListData("admin/update-comment", this.modelList)
              .then((res) => {
                if (res.code == 200) {
                  this.pupupTable = false;
                  this.$set(this.mode, "content", '');
                  this.Itemlist();
                }
              });
          }
        });
      },
      //扩展组删除
      handDeta(id) {
        this.delete.id = id;
        this.$confirm("是否删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .getListData("admin/delete-comment", this.delete)
              .then((res) => {
                if (res.code == 200) {
                  this.Itemlist();
                  this.devicesList();
                }
              });
          })
          .catch(() => {});
      },
  
      // //新建版本
      handDetaClick() {
        this.centerDialogVisible = true;
      },
      //版本列表
      devicesList() {
        this.$axios
          .getListData("admin/comments", this.Workers)
          .then((res) => {
            if (res.code === 200) {
              console.log(res.data.data)
              this.Pagination = res.data.meta.pagination;
              let time = res.data.data;
              this.tableData = time.map((v) => {
                return {
                  ...v,
                  description: v.description ? v.description : "——",
                  name: v.name ? v.name : "一",
                
                  created_at: this.$inserted(v.created_at),
                };
              });
            }
          });
      },
  
      close() {
        this.pupupTable = false;
        this.centerDialogVisible = false;
        this.useName = {};
        this.modify = {};
        this.Popup = false;
      },
      handCancel() {
        this.centerDialogVisible = false;
        this.useName = {};
      },
   
      //新建版本
      handConfirm() {
        if (!this.useName.pid) {
          this.useName.pid = sessionStorage.getItem("pid");
        }

        this.$refs.useName.validate((valid) => {
          if (valid) {
            let item = this.useName.content.replace(/\n|\r\n/g, "##");
          let list = item.split("##").filter((s) => s && s.trim()).join("##");
          let b = list.replace(/^\"|\"$/g, "").replace(/^\s+|\s+$/g, "");
           let modelPid ={
            pid :this.useName.pid,
            content :b

           }
            this.$axios
              .postListData("admin/comments", modelPid)
              .then((res) => {
                if ((res.code = 200)) {
                  this.centerDialogVisible = false;
            
  
                  this.devicesList();
                }
              });
          }
        });
      },
  
      handleClick(e) {
        console.log(e);
        this.$set(this.modify, "content", e.content);
        this.modify.pid = e.pid;
        this.modify.id = e.id
        this.Popup = true;
      },
      handClickCancel() {
        this.pupupTable = false;
        this.Popupvisible = false;
        this.Popup = false;
        this.mode = {};
        this.modify = {};
      },
  
      handleClose() {
        this.drawer = false;
      },
  
      //编辑版本
      handClickConfirm() {
        this.$refs.modify.validate((valid) => {
          if (valid) {
            this.$axios
              .postListData("admin/update-comment", this.modify)
              .then((res) => {
                this.Popup = false;
          
                this.devicesList();
  
              });
          }
        });
      },
      //删除版本
      handLeButton(e) {
        console.log(e)
         this.delete.id = e.id;
         this.$confirm("是否删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .getListData("admin/delete-comment", this.delete)
              .then((res) => {
                if (res.code === 200) {
                  if (this.tableData.length > 1) {
                    this.devicesList();
                  } else {
                    if (this.Workers.page >= 2) {
                      this.Workers.page = this.Workers.page - 1;
                      this.devicesList();
                    } else {
                      this.devicesList();
                    }
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "success",
                  });
                }
              });
          })
          .catch(() => {});
      },
  
      handleSizeChange(val) {
        this.Pagination.per_page = val;
      },
      //分页
      handleCurrentChange(val) {
        this.Workers.page = val;
        this.devicesList();
      },
    },
  };
  </script>
  
  <style scoped lang="less" scoped>
  /deep/.cell {
    max-height: 28px !important;
  }
  /deep/.el-table__empty-text {
    line-height: 53px;
  }
  /deep/.el-table__empty-block {
    min-height: 53px;
  }
  /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    display: flex;
  }
  /deep/.el-descriptions-item__container .el-descriptions-item__content {
    width: 130px;
    display: block;
    text-align: right;
    padding-right: 10px;
  }
  .distance {
    margin: 10px 0;
  }
  /deep/.el-descriptions-item__container {
    width: 200px;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    color: #000;
    border-radius: 4px;
    background-color: rgba(34, 73, 192, 0.06);
  }
  /deep/.el-descriptions-item__label:not(.is-bordered-label) {
    padding-left: 10px;
  }
  /deep/.el-select {
    width: 100% !important;
  }
  
  /deep/.el-dialog__body {
    box-sizing: border-box;
    padding: 20px;
  }
  /deep/.el-button--text {
    font-size: 18px;
    margin-top: -8px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px !important;
  }
  /deep/.el-table__body {
    width: 100% !important;
  }
  .dialog-footer {
    display: flex !important;
    justify-content: space-around !important;
  }
  .list {
    width: 92%;
    margin: 10px 0;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 22px;
    overflow: hidden;
    display: flex;
    .left {
      width: 18%;
      display: flex;
      justify-content: center;
  
      .my-label {
        background-color: #e1f3d8;
      }
  
      .my-content {
        background-color: #fde2e2;
      }
      .plus {
        padding: 10px;
        width: 100%;
      }
      .button-padding {
        width: 200px;
        color: #fff;
        height: 32px;
        background-color: #409eff;
        border-color: #409eff;
      }
      .br {
        margin: auto;
        padding-right: 25px;
        height: calc(100vh - 155px);
        border-left: 1px solid #e6e7ec;
      }
    }
    .right {
      width: 82%;
      .flex-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
  </style>
  